module.exports = __webpack_public_path__ + "static/media/interserve-logo-charcoal.26c970e7.svg";